import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ScrollContainer from 'react-indiana-drag-scroll';
import {twillBase} from "../../config/API";
import {isInternalLink} from "../../helpers/filters";
import './SubNav.scss';

const SubNav = ({name}) => {
    const [menuData, setMenuData] = useState([]);

    if (!name || name.length === 0) {
        return <React.Fragment />;
    }

    useEffect(() => {
        fetch(`${twillBase}/api/nav-blocks/${name}`)
            .then((res) => res.json())
            .then((data) => setMenuData(data))
            .catch((err) => console.error("Error fetching menu:", err));
    }, []);

    if (!menuData || !menuData.blocks || !menuData.blocks.length) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            <div id="site-sub-navigation" className="site-header__site-subNav">
                <div className="container">
                    <ScrollContainer
                        className="subNav"
                        component="ul">
                                        {menuData.blocks.map(link => (
                                            link.url !== undefined && (
                                                <li key={`${link.id}_${link.label}`} className="subNav__item" id={`subnav-item-${link.id}`}>
                                                    {
                                                        isInternalLink(link.url) ? (
                                                            <a
                                                                href={link.url}
                                                                className={window.location.pathname === new URL(link.url).pathname ? 'active' : ''}
                                                            >
                                                                {link.label}
                                                            </a>
                                                        ) : (
                                                            <a
                                                                href={link.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {link.label}
                                                            </a>
                                                        )
                                                    }                                                </li>
                                            )
                                        ))}
                    </ScrollContainer>

                </div>
            </div>
        </React.Fragment>
    );
};

SubNav.propTypes = {
   name: PropTypes.string.isRequired
};

export default SubNav;



// WEBPACK FOOTER //
// ./frontend/components/Header/SubNav.jsx